import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";


let inscricao = {
    'Nome': '',
    'Estado Civil': '',
    'Identidade': '',
    'Endereço': '',
    'Cidade': '',
    'Cidade de Prova': '',
    'E-mail': '',
    'Jurado': '',
    'Nome Social': '',
    'Data de Nascimento': '',
    'Sexo': '',
    'CPF': '',
    'Bairro': '',
    'CEP': '',
    'Telefone': '',
    'Pessoa Preta ou Parda': '',
    'Nacionalidade': '',
    'CadÚnico': '',
    'Necessidades Especiais': {}
}


const monta_formulario = (inscricao) => {

    let ins = Object.keys(inscricao);

    return ins.map((item,index) => {
        return (
            <Grid key={index}  item xs={12} md={4}>
                <MDTypography variant="p"><b>{item}: </b>{inscricao[item]}</MDTypography>
            </Grid>
        );
    })

}


function Formulario(props) {
    return (<MDBox>
        <Grid container justifyContent="left" spacing={3} p={4}>
            {monta_formulario(props.inscricao)}
        </Grid>
    </MDBox>);
}

export default Formulario;
